export function isWhite(input: string): boolean {
    input = normalize(input);

    if (input.includes('255,255,255')) {
        return true;
    } else if (input === '#ffffff' || input === '#fff') {
        return true;
    }

    return false;
}

export function normalize(input: string): string {
    return input
        .toLowerCase()
        .replace(/\s/g, '');
}